// Plaintext + Copy. No Reveal toggle: this is an internal-only superadmin
// portal where masking adds friction without security (the user already has
// the credentials, and the DB stores them plaintext). The `reveal` prop is
// kept for backwards-compat with existing call sites but is ignored — it's
// always shown.

import { useState } from "react";
import { Button } from "./Button";

interface Props {
  value: string | null | undefined;
  monospace?: boolean;
  /** @deprecated Always plaintext. Retained for backwards compatibility. */
  reveal?: boolean;
}

export function CopyableSecret({ value, monospace = true }: Props) {
  const [copied, setCopied] = useState(false);

  if (!value) return <span className="muted">—</span>;

  return (
    <span className="copyable-secret">
      <code className={monospace ? "copyable-secret-value" : ""}>{value}</code>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
          } catch {
            // ignore — fallback would be a textarea trick, not worth the bytes
          }
        }}
      >
        {copied ? "Copied!" : "Copy"}
      </Button>
    </span>
  );
}
